const HTML_ESCAPE_MAP: Record<string, string> = {
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;'
};

const COMBINING_DIACRITICS = new RegExp('[\\u0300-\\u036f]', 'g');

export const escapeHtml = (value: string) =>
	value.replace(/[&<>]/g, char => HTML_ESCAPE_MAP[char]);

export const normalizeSearchText = (value: string) =>
	value.normalize('NFD').replace(COMBINING_DIACRITICS, '').toLowerCase();
